import React from 'react';
import {Table as BaseTable} from 'desktop/sports/nhl/players-list/classic';

class Table extends BaseTable {}

export {Table};
